const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, thumbnail, id, product, variantImages) {
    const arrImage = thumbnail.getAttribute('image')
      .split('?')[0];
    const strNewImage = arrImage;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
            if(document.querySelectorAll('.variant-picker__option-values').length){
            const selects = document.querySelectorAll('#'+ id + ' [class*=variant-picker__option-values]');
            const options = selects[index].querySelectorAll('input');
            options.forEach((option)=>{
                if (option.value == optionValue) {
                option.checked = true;
                var changeEvent = new Event('change',{
                    changeEvent: 'option2'
                });
                //   changeEvent.target = { name: 'option' };
                var details = {
                    mrkCustomTrigger: true,
                    };
                changeEvent.details = details;
                
                document.querySelector('[data-option-selector]').dispatchEvent(changeEvent);
                
                return;
                }
            })
            }else{
                const selects = document.querySelectorAll('#'+ id + ' [class*=variant-picker__option] x-listbox');
                const options = selects[index].querySelectorAll('button');
                options.forEach((option)=>{
                    if (option.getAttribute('value') == optionValue) {
                    option.click();
                    var changeEvent = new Event('change',{
                        changeEvent: 'option2'
                    });
                    //   changeEvent.target = { name: 'option' };
                    var details = {
                        mrkCustomTrigger: true,
                        };
                    changeEvent.details = details;
                    
                    document.querySelector('[data-option-selector]').dispatchEvent(changeEvent);
                    
                    return;
                    }
                })
            }
        }
      });
    }
  },
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const thumbnails = document.querySelectorAll('#'+ sectionId + ' .product-gallery__thumbnail');
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, thumbnail, sectionId, productObject, variantImages),
              );
            });
              document.addEventListener('mrkSlideChanged', event => {
                var _this = this;
                setTimeout(function(){
                  const thumbnail = document.querySelector('.product-gallery__thumbnail[aria-current="true"]');
                  _this._updateVariant(event, thumbnail, sectionId, productObject, variantImages)
                },300);
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== 'loading') {
    selectVariantByClickingImage._selectVariant();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      () => selectVariantByClickingImage._selectVariant(),
    );
  }
  
